export const PRIMARY_COLOR = "#28B463";
export const BLUE_COLOR = "blue";
export const Green_COLOR = "#00b5ad";
export const GREEN = "green";
export const Yellow_COLOR = "#fbbd08";
export const WHITE_COLOR = "white";
export const RED_COLOR = "red";
